module.exports = __webpack_public_path__ + "img/avator.c58e4651.png";